module.exports = __webpack_public_path__ + "img/resized-cover8.6b26939e.png";